<template>
  <div>
    <el-card :body-style="cardBodyStyle">
      <el-form label-width="80px" :inline="true" ref="form" :model="form" :rules="formRules">
        <div>
          <el-form-item label="表名" prop="tableName">
            <el-input v-model="form.tableName" @input="handleInputTableName" size="small" style="width: 200px;">
            </el-input>
          </el-form-item>
          <el-form-item label="表名前缀" prop="tablePrefix">
            <el-input v-model="form.tablePrefix" @input="handleInputTablePrefix" size="small" placeholder="T_TEST"
              style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="服务名" prop="moduleName">
            <el-input v-model="form.moduleName" size="small" placeholder="test" style="width: 200px;">
            </el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="界面" prop="menu.menuName">
            <el-input v-model="form.menu.menuName" size="small" style="width: 200px;">
              <el-button slot="append" icon="el-icon-search" size="mini" @click="handlePopupMenuTree"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="表格名称" prop="tName">
            <el-input v-model="form.tName" size="small" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="vue路径" prop="vuePath">
            <el-input v-model="form.vuePath" size="small" placeholder="C:\workspaces\sgiip\Proj_SgIIP_Src_vue"
              style="width: 495px;">
              <template slot="append">/src/view/{{form.moduleName}}</template>
            </el-input>
          </el-form-item>


        </div>

      </el-form>
    </el-card>

    <el-card :body-style="cardBodyStyle">
      <el-button size="mini" type="primary" @click="handleSearch('form')">查询</el-button>
      <el-button size="mini" type="success" @click="handleSave('form')">保存</el-button>
      <el-button size="mini" type="warning" @click="handleGenerate('form')">生成</el-button>
      <el-button size="mini" type="danger" @click="handleJSON('form')">JSON</el-button>
    </el-card>



    <el-card :body-style="cardBodyStyle">
      <el-table :data="tableData" ref="tableData" border>
        <el-table-column prop="sort" type="index" label="序号" align="center" width="60">
        </el-table-column>
        <el-table-column label="数据库" header-align="center">
          <el-table-column prop="fieldName" label="字段名" width="140" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="fieldComment" label="注释" width="140" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="fieldType" label="字段类型" width="140" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="length" label="长度" width="80" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="precision" label="精度" width="80" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="nullFlag" label="非空" width="80" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.nullFlag" disabled true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="pkFlag" label="主键" width="80" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.pkFlag" disabled true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column> -->
        </el-table-column>
        <el-table-column label="列表" header-align="center">

          <el-table-column prop="label" label="表头" width="120" header-align="center" align="center"
            show-overflow-tooltip> </el-table-column>
          <el-table-column prop="headerAlign" label="表头对齐" width="120" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">

              <el-select v-model="scope.row.headerAlign" size="small" style="width: 100px;">
                <el-option label="居中" value="center"> </el-option>
                <el-option label="左对齐" value="left"> </el-option>
                <el-option label="右对齐" value="right"> </el-option>
              </el-select>

            </template>

          </el-table-column>
          <el-table-column prop="showFlag" label="显示" width="80" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.showFlag" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column prop="width" label="列宽" width="80" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="align" label="对齐" width="120" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">

              <el-select v-model="scope.row.align" size="small" style="width: 100px;">
                <el-option label="居中" value="center"> </el-option>
                <el-option label="左对齐" value="left"> </el-option>
                <el-option label="右对齐" value="right"> </el-option>
              </el-select>

            </template>


          </el-table-column>
          <el-table-column prop="sortable" label="排序" width="80" header-align="center" align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.sortable" true-label="1" false-label="0"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="colType" label="类型" width="80" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="formatter" label="格式化" width="80" header-align="center" align="center"
            show-overflow-tooltip>
          </el-table-column>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="80px">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>





    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisible" width="700px">
      <el-form label-width="80px" :inline="true" :model="tableField">
        <div>
          <el-form-item label="表头">
            <el-input v-model="tableField.label" size="small" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="表头对齐">
            <el-select v-model="tableField.headerAlign" size="small" style="width: 100px;">
              <el-option label="居中" value="center"> </el-option>
              <el-option label="左对齐" value="left"> </el-option>
              <el-option label="右对齐" value="right"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示">
            <el-checkbox v-model="tableField.showFlag" true-label="1" false-label="0"></el-checkbox>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="列宽">
            <el-input v-model="tableField.width" size="small" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="列宽">
            <el-select v-model="tableField.align" size="small" style="width: 100px;">
              <el-option label="居中" value="center"> </el-option>
              <el-option label="左对齐" value="left"> </el-option>
              <el-option label="右对齐" value="right"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-checkbox v-model="tableField.sortable" true-label="1" false-label="0"></el-checkbox>
          </el-form-item>
        </div>

      </el-form>
      <span slot="footer">
        <el-button size="small" type="success" @click="handleComfirm('tableField')">确定</el-button>
        <el-button size="small" type="danger" @click="handleComfirmCancel">取消</el-button>
      </span>
    </el-dialog>

    <popup-menu-tree ref="PopupMenuTree" v-on:receiveFromChild="receiveFromPopupMenuTree"></popup-menu-tree>
  </div>
</template>

<script>
  import axios from '@/axios'
  import tools from '@/tools'
  import PopupMenuTree from '@/components/system/PopupMenuTree.vue'
  export default {
    components: {

      PopupMenuTree
    },


    data() {

      return {
        cardBodyStyle: tools.style.card,
        form: {
          tableName: '',
          tablePrefix: '',
          moduleName: '',
          serviceName: '',
          parentPackageName: '',
          vuePath: '',
          menu: {
            id: '',
            text: ''
          }
        },
        tableData: [],
        formRules: {
          tableName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],

          vuePath: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          'menu.menuName': [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          tName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
        },
        tableField: {
          label: '',
          prop: '',
          width: '100',
          headerAlign: 'center',
          align: 'center',
          formatter: '',
          sortable: '0',
          colType: 'text'
        },
        dialogVisible: false




      }

    },
    methods: {

      handleSearch(form) {
        // this.$refs[form].validate((valid) => {
        //   if (valid) {
        var url = 'framework/TableField/query.do'
        var param = {
          tableName: this.form.tableName
        }
        axios.post(url, param).then(response => {
          if (response.data.code == 0) {
            this.form.tablePrefix = response.data.data[0].tablePrefix
            this.form.moduleName = response.data.data[0].moduleName
            this.form.serviceName = response.data.data[0].serviceName
            this.form.parentPackageName = response.data.data[0].parentPackageName
            this.form.processKey = response.data.data[0].processKey
            this.form.vuePath = response.data.data[0].vuePath
            this.tableData = response.data.data
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
            this.tableData = []
          }
        })
        //   } else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // })
      },

      handlePopupMenuTree() {
        this.$refs.PopupMenuTree.show()
      },
      receiveFromPopupMenuTree(value) {
        this.form.menu = value
      },
      handleEdit(row) {
        this.tableField = row
        this.dialogVisible = true
      },
      handleComfirm(row) {
        this.dialogVisible = false
      },
      handleComfirmCancel() {
        this.dialogVisible = false
      },
      handleSave(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = 'framework/TableField/update.do'
            var param = {
              tableName: this.form.tableName,
              tablePrefix: this.form.tablePrefix,
              moduleName: this.form.moduleName,
              serviceName: this.form.serviceName,
              parentPackageName: this.form.parentPackageName,
              vuePath: this.form.vuePath,
              json: JSON.stringify(this.tableData)
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                this.handleSearch(form)
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
              }
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      handleGenerate(form) {
        this.$confirm('此操作将覆盖现有代码和已生成列数据,请谨慎操作,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs[form].validate((valid) => {
            if (valid) {
              var url = this.form.moduleName + '/Generate/maint.do'
              var param = {
                jsonForm: JSON.stringify(this.form),
                jsonFileds: JSON.stringify(this.tableData)
              }
              axios.post(url, param).then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    type: 'success',
                    message: '操作成功!'
                  });
                  this.handleSearch(form)
                } else {
                  this.$message({
                    type: 'error',
                    message: '操作失败!' + response.data.msg
                  });
                }
              })

            } else {
              console.log('error submit!!');
              return false;
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！！'
          });
        });
      },


      handleJSON(form) {
        this.$confirm('此操作将覆盖现有JSON文件,请谨慎操作,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          var url = this.form.moduleName + '/Generate/json.do'
          var param = {
            jsonForm: JSON.stringify(this.form),
            jsonFileds: JSON.stringify(this.tableData)
          }
          axios.post(url, param).then(response => {
            if (response.data.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.handleSearch(form)
            } else {
              this.$message({
                type: 'error',
                message: '操作失败!' + response.data.msg
              });
            }
          })




        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！！'
          });
        });
      },


      handleInputTableName(value) {
        this.form.tableName = value.toUpperCase()
      },
      handleInputTablePrefix(value) {
        this.form.tablePrefix = value.toUpperCase()
      }
    }

  }
</script>

<style>



</style>



// WEBPACK FOOTER //
// src/view/generater/columns.vue